import { ISubscription } from "../../../entities/src/subscription";
import { Modelable } from "../../../entities/src/modelable";

export class Subscription implements Modelable<ISubscription> {
    constructor(public data: ISubscription) {}
}
